import { useAuthStore } from '../../stores/authStore';

export default function Dashboard() {
  const { user } = useAuthStore();

  return (
    <div>
      <h1 className="font-western text-3xl text-cream mb-8">
        Welcome back, {user?.displayName || user?.username}!
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="card p-6">
          <h3 className="text-text-muted text-sm uppercase tracking-wider mb-2">Orders</h3>
          <p className="text-3xl font-bold text-cream">0</p>
        </div>
        <div className="card p-6">
          <h3 className="text-text-muted text-sm uppercase tracking-wider mb-2">Purchases</h3>
          <p className="text-3xl font-bold text-cream">0</p>
        </div>
        <div className="card p-6">
          <h3 className="text-text-muted text-sm uppercase tracking-wider mb-2">Downloads</h3>
          <p className="text-3xl font-bold text-cream">0</p>
        </div>
      </div>

      <div className="card p-6">
        <h2 className="font-semibold text-cream mb-4">Recent Activity</h2>
        <p className="text-text-secondary">No recent activity</p>
      </div>
    </div>
  );
}
